<template>
    <div id="base" class="">

    

      <!-- Unnamed (Rectangle) -->
      <div id="u4037" class="ax_default box_1">
        <div id="u4037_div" class=""></div>
        <div id="u4037_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4038" class="ax_default box_1">
        <div id="u4038_div" class=""></div>
        <div id="u4038_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4039" class="ax_default button" @click="setFlag1(1)">
        <div id="u4039_div" class=""></div>
        <div id="u4039_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4040" class="ax_default button" @click="setFlag1(2)">
        <div id="u4040_div" class=""></div>
        <div id="u4040_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u4041" class="ax_default line">
        <img id="u4041_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u4041_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4042" class="ax_default button" @click="setFlag1(3)">
        <div id="u4042_div" class=""></div>
        <div id="u4042_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>



      <!-- Unnamed (Group) -->
      <div id="u4044" class="ax_default" data-left="259" data-top="926" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u4045" class="ax_default label">
          <div id="u4045_div" class=""></div>
          <div id="u4045_text" class="text ">
            <p><span>能耗绩效详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4046" class="ax_default box_1">
          <div id="u4046_div" class=""></div>
          <div id="u4046_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4047" class="ax_default label">
          <div id="u4047_div" class=""></div>
          <div id="u4047_text" class="text ">
            <p><span>能效类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u4048" class="ax_default droplist">
          <div id="u4048_div" class=""></div>
          <select id="u4048_input" class="u4048_input"  v-model="queryParams.performancetype">
            <option class="u4048_input_option" selected value="">请选择</option>
            <option class="u4048_input_option" value="0">总能耗</option>
            <option class="u4048_input_option" value="1">单位产值能耗</option>
            <option class="u4048_input_option" value="2">单位面积能耗</option>
            <option class="u4048_input_option" value="3">单位面积电耗</option>
            <option class="u4048_input_option" value="4">单位面积用水</option>
            <option class="u4048_input_option" value="5">单位面积空调用电</option>
            <option class="u4048_input_option" value="6">人均能耗</option>
            <option class="u4048_input_option" value="7">单位人均电耗</option>
            <option class="u4048_input_option" value="8">单位人均用水</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4049" class="ax_default label">
          <div id="u4049_div" class=""></div>
          <div id="u4049_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4050" class="ax_default image">
          <img id="u4050_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u392.png"/>
          <div id="u4050_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4051" class="ax_default primary_button"  @click="handleQuery">
          <div id="u4051_div" class=""></div>
          <div id="u4051_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4052" class="ax_default box_1">
                      
<div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
                <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="performancemonth" />
                <el-table-column label="能耗类型" align="center" prop="performancetype" />
                <el-table-column label="能耗绩效" align="center" prop="performance" />
             
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

       

        <!-- Unnamed (Line) -->
        <div id="u4054" class="ax_default _水平线">
          <img id="u4054_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u4054_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

     

        <!-- Unnamed (Rectangle) -->
        <div id="u4056" class="ax_default primary_button">
          <div id="u4056_div" class=""></div>
          <div id="u4056_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4057" class="ax_default label">
          <div id="u4057_div" class=""></div>
          <div id="u4057_text" class="text ">
            <p><span>暂无数据</span></p>
          </div>
        </div>

      

      
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4060" class="ax_default box_1">
        <div id="u4060_div" class=""></div>
        <div id="u4060_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

 

      <!-- Unnamed (Rectangle) -->
      <div id="u4062" class="ax_default label">
        <div id="u4062_div" class=""></div>
        <div id="u4062_text" class="text ">
          <p><span>{{performanceLevel1VO.totalYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4063" class="ax_default label">
        <div id="u4063_div" class=""></div>
        <div id="u4063_text" class="text ">
          <p><span>同比变化率</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4064" class="ax_default label">
        <div id="u4064_div" class=""></div>
        <div id="u4064_text" class="text ">
          <p><span>{{performanceLevel1VO.totalChangerateYear}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4065" class="ax_default label">
        <div id="u4065_div" class=""></div>
        <div id="u4065_text" class="text ">
          <p><span>下一年度预测</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4066" class="ax_default label">
        <div id="u4066_div" class=""></div>
        <div id="u4066_text" class="text ">
          <p><span>{{performanceLevel1VO.totalForecastYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4067" class="ax_default label">
        <div id="u4067_div" class=""></div>
        <div id="u4067_text" class="text ">
          <p><span>同比变化量</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4068" class="ax_default label">
        <div id="u4068_div" class=""></div>
        <div id="u4068_text" class="text ">
          <p><span>{{performanceLevel1VO.totalChangeYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4069" class="ax_default label">
        <div id="u4069_div" class=""></div>
        <div id="u4069_text" class="text ">
          <p><span>能耗评价</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u4070" class="ax_default label">
        <div id="u4070_div" class=""></div>
        <div id="u4070_text" class="text ">
          <p><span>{{performanceLevel1VO.totalEvaluateYear}}</span></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u4071" class="ax_default image"  v-if="performanceLevel1VO.totalChangeYear>=0">
        <img id="u4071_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
        <div id="u4071_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u4072" class="ax_default image"  v-if="performanceLevel1VO.totalChangeYear>=0">
        <img id="u4072_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
        <div id="u4072_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
  <!-- Unnamed (Image) -->
      <div id="u4071" class="ax_default image"  v-if="performanceLevel1VO.totalChangeYear<0">
        <img id="u4071_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u4071_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u4072" class="ax_default image"  v-if="performanceLevel1VO.totalChangeYear<0">
        <img id="u4072_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u4072_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
      <!-- Unnamed (Image) -->
      <div id="u4073" class="ax_default image">
        <img id="u4073_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u4073_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u4074" class="ax_default image">
        <img id="u4074_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u4074_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4075" class="ax_default" data-left="269" data-top="254" data-width="373" data-height="202">

        <!-- Unnamed (Rectangle) -->
        <div id="u4076" class="ax_default box_1">
          <div id="u4076_div" class=""></div>
          <div id="u4076_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4077" class="ax_default label">
          <div id="u4077_div" class=""></div>
          <div id="u4077_text" class="text ">
            <p><span>单位产值能耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4078" class="ax_default label">
          <div id="u4078_div" class=""></div>
          <div id="u4078_text" class="text ">
            <p><span>单位产值能耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4079" class="ax_default label">
          <div id="u4079_div" class=""></div>
          <div id="u4079_text" class="text ">
            <p><span>{{performanceLevel1VO.outputYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4080" class="ax_default label">
          <div id="u4080_div" class=""></div>
          <div id="u4080_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4081" class="ax_default label">
          <div id="u4081_div" class=""></div>
          <div id="u4081_text" class="text ">
            <p><span>{{performanceLevel1VO.outputChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4082" class="ax_default label">
          <div id="u4082_div" class=""></div>
          <div id="u4082_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4083" class="ax_default label">
          <div id="u4083_div" class=""></div>
          <div id="u4083_text" class="text ">
            <p><span>{{performanceLevel1VO.outputForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4084" class="ax_default label">
          <div id="u4084_div" class=""></div>
          <div id="u4084_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4085" class="ax_default label">
          <div id="u4085_div" class=""></div>
          <div id="u4085_text" class="text ">
            <p><span>{{performanceLevel1VO.outputChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4086" class="ax_default label">
          <div id="u4086_div" class=""></div>
          <div id="u4086_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4087" class="ax_default label">
          <div id="u4087_div" class=""></div>
          <div id="u4087_text" class="text ">
            <p><span>{{performanceLevel1VO.outputEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4088" class="ax_default image"  v-if="performanceLevel1VO.outputChangeYear>=0">
          <img id="u4088_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4088_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4089" class="ax_default image" v-if="performanceLevel1VO.outputChangeYear>=0">
          <img id="u4089_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4089_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
         <!-- Unnamed (Image) -->
        <div id="u4088" class="ax_default image"  v-if="performanceLevel1VO.outputChangeYear<0">
          <img id="u4088_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4088_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4089" class="ax_default image" v-if="performanceLevel1VO.outputChangeYear<0">
          <img id="u4089_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4089_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4090" class="ax_default" data-left="651" data-top="254" data-width="373" data-height="202">

        <!-- Unnamed (Rectangle) -->
        <div id="u4091" class="ax_default box_1">
          <div id="u4091_div" class=""></div>
          <div id="u4091_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4092" class="ax_default label">
          <div id="u4092_div" class=""></div>
          <div id="u4092_text" class="text ">
            <p><span>单位面积综合能耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4093" class="ax_default label">
          <div id="u4093_div" class=""></div>
          <div id="u4093_text" class="text ">
            <p><span>单位面积综合能耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4094" class="ax_default label">
          <div id="u4094_div" class=""></div>
          <div id="u4094_text" class="text ">
            <p><span>{{performanceLevel1VO.areaenergyYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4095" class="ax_default label">
          <div id="u4095_div" class=""></div>
          <div id="u4095_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4096" class="ax_default label">
          <div id="u4096_div" class=""></div>
          <div id="u4096_text" class="text ">
            <p><span>{{performanceLevel1VO.areaenergyChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4097" class="ax_default label">
          <div id="u4097_div" class=""></div>
          <div id="u4097_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4098" class="ax_default label">
          <div id="u4098_div" class=""></div>
          <div id="u4098_text" class="text ">
            <p><span>{{performanceLevel1VO.areaenergyForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4099" class="ax_default label">
          <div id="u4099_div" class=""></div>
          <div id="u4099_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4100" class="ax_default label">
          <div id="u4100_div" class=""></div>
          <div id="u4100_text" class="text ">
            <p><span>{{performanceLevel1VO.areaenergyChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4101" class="ax_default label">
          <div id="u4101_div" class=""></div>
          <div id="u4101_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4102" class="ax_default label">
          <div id="u4102_div" class=""></div>
          <div id="u4102_text" class="text ">
            <p><span>{{performanceLevel1VO.areaenergyEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4103" class="ax_default image" v-if="performanceLevel1VO.areaenergyChangeYear>=0">
          <img id="u4103_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4103_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4104" class="ax_default image" v-if="performanceLevel1VO.areaenergyChangeYear>=0">
          <img id="u4104_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4104_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
          <!-- Unnamed (Image) -->
        <div id="u4103" class="ax_default image" v-if="performanceLevel1VO.areaenergyChangeYear<0">
          <img id="u4103_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4103_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4104" class="ax_default image" v-if="performanceLevel1VO.areaenergyChangeYear<0">
          <img id="u4104_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4104_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4105" class="ax_default" data-left="1031" data-top="254" data-width="373" data-height="202">

        <!-- Unnamed (Rectangle) -->
        <div id="u4106" class="ax_default box_1">
          <div id="u4106_div" class=""></div>
          <div id="u4106_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4107" class="ax_default label">
          <div id="u4107_div" class=""></div>
          <div id="u4107_text" class="text ">
            <p><span>单位面积电耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4108" class="ax_default label">
          <div id="u4108_div" class=""></div>
          <div id="u4108_text" class="text ">
            <p><span>单位面积电耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4109" class="ax_default label">
          <div id="u4109_div" class=""></div>
          <div id="u4109_text" class="text ">
            <p><span>{{performanceLevel1VO.areapowerYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4110" class="ax_default label">
          <div id="u4110_div" class=""></div>
          <div id="u4110_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4111" class="ax_default label">
          <div id="u4111_div" class=""></div>
          <div id="u4111_text" class="text ">
            <p><span>{{performanceLevel1VO.areapowerChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4112" class="ax_default label">
          <div id="u4112_div" class=""></div>
          <div id="u4112_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4113" class="ax_default label">
          <div id="u4113_div" class=""></div>
          <div id="u4113_text" class="text ">
            <p><span>{{performanceLevel1VO.areapowerForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4114" class="ax_default label">
          <div id="u4114_div" class=""></div>
          <div id="u4114_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4115" class="ax_default label">
          <div id="u4115_div" class=""></div>
          <div id="u4115_text" class="text ">
            <p><span>{{performanceLevel1VO.areapowerChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4116" class="ax_default label">
          <div id="u4116_div" class=""></div>
          <div id="u4116_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4117" class="ax_default label">
          <div id="u4117_div" class=""></div>
          <div id="u4117_text" class="text ">
            <p><span>{{performanceLevel1VO.areapowerEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4118" class="ax_default image" v-if="performanceLevel1VO.areapowerChangeYear>=0">
          <img id="u4118_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4118_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4119" class="ax_default image" v-if="performanceLevel1VO.areapowerChangeYear>=0">
          <img id="u4119_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4119_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
          <div id="u4118" class="ax_default image" v-if="performanceLevel1VO.areapowerChangeYear<0">
          <img id="u4118_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4118_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4119" class="ax_default image" v-if="performanceLevel1VO.areapowerChangeYear<0">
          <img id="u4119_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4119_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4120" class="ax_default" data-left="269" data-top="472" data-width="373" data-height="202">

        <!-- Unnamed (Rectangle) -->
        <div id="u4121" class="ax_default box_1">
          <div id="u4121_div" class=""></div>
          <div id="u4121_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4122" class="ax_default label">
          <div id="u4122_div" class=""></div>
          <div id="u4122_text" class="text ">
            <p><span>单位面积用水</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4123" class="ax_default label">
          <div id="u4123_div" class=""></div>
          <div id="u4123_text" class="text ">
            <p><span>单位面积用水量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4124" class="ax_default label">
          <div id="u4124_div" class=""></div>
          <div id="u4124_text" class="text ">
            <p><span>{{performanceLevel1VO.areawaterYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4125" class="ax_default label">
          <div id="u4125_div" class=""></div>
          <div id="u4125_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4126" class="ax_default label">
          <div id="u4126_div" class=""></div>
          <div id="u4126_text" class="text ">
            <p><span>{{performanceLevel1VO.areawaterChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4127" class="ax_default label">
          <div id="u4127_div" class=""></div>
          <div id="u4127_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4128" class="ax_default label">
          <div id="u4128_div" class=""></div>
          <div id="u4128_text" class="text ">
            <p><span>{{performanceLevel1VO.areawaterForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4129" class="ax_default label">
          <div id="u4129_div" class=""></div>
          <div id="u4129_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4130" class="ax_default label">
          <div id="u4130_div" class=""></div>
          <div id="u4130_text" class="text ">
            <p><span>{{performanceLevel1VO.areawaterChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4131" class="ax_default label">
          <div id="u4131_div" class=""></div>
          <div id="u4131_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4132" class="ax_default label">
          <div id="u4132_div" class=""></div>
          <div id="u4132_text" class="text ">
            <p><span>{{performanceLevel1VO.areawaterEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4133" class="ax_default image" v-if="performanceLevel1VO.areawaterChangeYear>=0">
          <img id="u4133_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4133_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4134" class="ax_default image" v-if="performanceLevel1VO.areawaterChangeYear>=0">
          <img id="u4134_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4134_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
          <!-- Unnamed (Image) -->
        <div id="u4133" class="ax_default image" v-if="performanceLevel1VO.areawaterChangeYear<0">
          <img id="u4133_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4133_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4134" class="ax_default image" v-if="performanceLevel1VO.areawaterChangeYear<0">
          <img id="u4134_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4134_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4135" class="ax_default" data-left="651" data-top="472" data-width="373" data-height="200">

        <!-- Unnamed (Rectangle) -->
        <div id="u4136" class="ax_default box_1">
          <div id="u4136_div" class=""></div>
          <div id="u4136_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4137" class="ax_default label">
          <div id="u4137_div" class=""></div>
          <div id="u4137_text" class="text ">
            <p><span>单位面积空调用电</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4138" class="ax_default label">
          <div id="u4138_div" class=""></div>
          <div id="u4138_text" class="text ">
            <p><span>用电量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4139" class="ax_default label">
          <div id="u4139_div" class=""></div>
          <div id="u4139_text" class="text ">
            <p><span>{{performanceLevel1VO.areaairYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4140" class="ax_default label">
          <div id="u4140_div" class=""></div>
          <div id="u4140_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4141" class="ax_default label">
          <div id="u4141_div" class=""></div>
          <div id="u4141_text" class="text ">
            <p><span>{{performanceLevel1VO.areaairChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4142" class="ax_default label">
          <div id="u4142_div" class=""></div>
          <div id="u4142_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4143" class="ax_default label">
          <div id="u4143_div" class=""></div>
          <div id="u4143_text" class="text ">
            <p><span>{{performanceLevel1VO.areaairForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4144" class="ax_default label">
          <div id="u4144_div" class=""></div>
          <div id="u4144_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4145" class="ax_default label">
          <div id="u4145_div" class=""></div>
          <div id="u4145_text" class="text ">
            <p><span>{{performanceLevel1VO.areaairChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4146" class="ax_default label">
          <div id="u4146_div" class=""></div>
          <div id="u4146_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4147" class="ax_default label">
          <div id="u4147_div" class=""></div>
          <div id="u4147_text" class="text ">
            <p><span>{{performanceLevel1VO.areaairEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4148" class="ax_default image" v-if="performanceLevel1VO.areaairChangeYear>=0">
          <img id="u4148_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4148_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4149" class="ax_default image" v-if="performanceLevel1VO.areaairChangeYear>=0">
          <img id="u4149_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4149_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
           <!-- Unnamed (Image) -->
        <div id="u4148" class="ax_default image" v-if="performanceLevel1VO.areaairChangeYear<0">
          <img id="u4148_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4148_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4149" class="ax_default image" v-if="performanceLevel1VO.areaairChangeYear<0">
          <img id="u4149_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4149_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4150" class="ax_default" data-left="1031" data-top="472" data-width="373" data-height="201">

        <!-- Unnamed (Rectangle) -->
        <div id="u4151" class="ax_default box_1">
          <div id="u4151_div" class=""></div>
          <div id="u4151_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4152" class="ax_default label">
          <div id="u4152_div" class=""></div>
          <div id="u4152_text" class="text ">
            <p><span>人均能耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4153" class="ax_default label">
          <div id="u4153_div" class=""></div>
          <div id="u4153_text" class="text ">
            <p><span>人均综合能耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4154" class="ax_default label">
          <div id="u4154_div" class=""></div>
          <div id="u4154_text" class="text ">
            <p><span>{{performanceLevel1VO.perYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4155" class="ax_default label">
          <div id="u4155_div" class=""></div>
          <div id="u4155_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4156" class="ax_default label">
          <div id="u4156_div" class=""></div>
          <div id="u4156_text" class="text ">
            <p><span>{{performanceLevel1VO.perChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4157" class="ax_default label">
          <div id="u4157_div" class=""></div>
          <div id="u4157_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4158" class="ax_default label">
          <div id="u4158_div" class=""></div>
          <div id="u4158_text" class="text ">
            <p><span>{{performanceLevel1VO.perForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4159" class="ax_default label">
          <div id="u4159_div" class=""></div>
          <div id="u4159_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4160" class="ax_default label">
          <div id="u4160_div" class=""></div>
          <div id="u4160_text" class="text ">
            <p><span>{{performanceLevel1VO.perChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4161" class="ax_default label">
          <div id="u4161_div" class=""></div>
          <div id="u4161_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4162" class="ax_default label">
          <div id="u4162_div" class=""></div>
          <div id="u4162_text" class="text ">
            <p><span>{{performanceLevel1VO.perEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4163" class="ax_default image" v-if="performanceLevel1VO.perChangeYear>=0">
          <img id="u4163_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4163_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4164" class="ax_default image" v-if="performanceLevel1VO.perChangeYear>=0">
          <img id="u4164_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4164_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
          <!-- Unnamed (Image) -->
        <div id="u4163" class="ax_default image" v-if="performanceLevel1VO.perChangeYear<0">
          <img id="u4163_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4163_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4164" class="ax_default image" v-if="performanceLevel1VO.perChangeYear<0">
          <img id="u4164_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4164_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4165" class="ax_default" data-left="269" data-top="692" data-width="373" data-height="201">

        <!-- Unnamed (Rectangle) -->
        <div id="u4166" class="ax_default box_1">
          <div id="u4166_div" class=""></div>
          <div id="u4166_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4167" class="ax_default label">
          <div id="u4167_div" class=""></div>
          <div id="u4167_text" class="text ">
            <p><span>单位人均电耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4168" class="ax_default label">
          <div id="u4168_div" class=""></div>
          <div id="u4168_text" class="text ">
            <p><span>单位人均电耗</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4169" class="ax_default label">
          <div id="u4169_div" class=""></div>
          <div id="u4169_text" class="text ">
            <p><span>{{performanceLevel1VO.perpowerYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4170" class="ax_default label">
          <div id="u4170_div" class=""></div>
          <div id="u4170_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4171" class="ax_default label">
          <div id="u4171_div" class=""></div>
          <div id="u4171_text" class="text ">
            <p><span>{{performanceLevel1VO.perpowerChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4172" class="ax_default label">
          <div id="u4172_div" class=""></div>
          <div id="u4172_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4173" class="ax_default label">
          <div id="u4173_div" class=""></div>
          <div id="u4173_text" class="text ">
            <p><span>{{performanceLevel1VO.perpowerForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4174" class="ax_default label">
          <div id="u4174_div" class=""></div>
          <div id="u4174_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4175" class="ax_default label">
          <div id="u4175_div" class=""></div>
          <div id="u4175_text" class="text ">
            <p><span>{{performanceLevel1VO.perpowerChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4176" class="ax_default label">
          <div id="u4176_div" class=""></div>
          <div id="u4176_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4177" class="ax_default label">
          <div id="u4177_div" class=""></div>
          <div id="u4177_text" class="text ">
            <p><span>{{performanceLevel1VO.perpowerEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4178" class="ax_default image"  v-if="performanceLevel1VO.perpowerChangeYear>=0">
          <img id="u4178_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4178_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4179" class="ax_default image"  v-if="performanceLevel1VO.perpowerChangeYear>=0">
          <img id="u4179_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4179_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
           <!-- Unnamed (Image) -->
        <div id="u4178" class="ax_default image"  v-if="performanceLevel1VO.perpowerChangeYear<0">
          <img id="u4178_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4178_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4179" class="ax_default image"  v-if="performanceLevel1VO.perpowerChangeYear<0">
          <img id="u4179_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4179_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u4180" class="ax_default" data-left="651" data-top="692" data-width="373" data-height="201">

        <!-- Unnamed (Rectangle) -->
        <div id="u4181" class="ax_default box_1">
          <div id="u4181_div" class=""></div>
          <div id="u4181_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4182" class="ax_default label">
          <div id="u4182_div" class=""></div>
          <div id="u4182_text" class="text ">
            <p><span>单位人均用水</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4183" class="ax_default label">
          <div id="u4183_div" class=""></div>
          <div id="u4183_text" class="text ">
            <p><span>用水量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4184" class="ax_default label">
          <div id="u4184_div" class=""></div>
          <div id="u4184_text" class="text ">
            <p><span>{{performanceLevel1VO.perwaterYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4185" class="ax_default label">
          <div id="u4185_div" class=""></div>
          <div id="u4185_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4186" class="ax_default label">
          <div id="u4186_div" class=""></div>
          <div id="u4186_text" class="text ">
            <p><span>{{performanceLevel1VO.perwaterChangerateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4187" class="ax_default label">
          <div id="u4187_div" class=""></div>
          <div id="u4187_text" class="text ">
            <p><span>下一年度预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4188" class="ax_default label">
          <div id="u4188_div" class=""></div>
          <div id="u4188_text" class="text ">
            <p><span>{{performanceLevel1VO.perwaterForecastYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4189" class="ax_default label">
          <div id="u4189_div" class=""></div>
          <div id="u4189_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4190" class="ax_default label">
          <div id="u4190_div" class=""></div>
          <div id="u4190_text" class="text ">
            <p><span>{{performanceLevel1VO.perwaterChangeYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4191" class="ax_default label">
          <div id="u4191_div" class=""></div>
          <div id="u4191_text" class="text ">
            <p><span>能耗评价</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u4192" class="ax_default label">
          <div id="u4192_div" class=""></div>
          <div id="u4192_text" class="text ">
            <p><span>{{performanceLevel1VO.perwaterEvaluateYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4193" class="ax_default image"  v-if="performanceLevel1VO.perwaterChangeYear>=0">
          <img id="u4193_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4193_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4194" class="ax_default image"  v-if="performanceLevel1VO.perwaterChangeYear>=0">
          <img id="u4194_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u4194_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>
        <!-- Unnamed (Image) -->
        <div id="u4193" class="ax_default image"  v-if="performanceLevel1VO.perwaterChangeYear<0">
          <img id="u4193_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4193_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u4194" class="ax_default image"  v-if="performanceLevel1VO.perwaterChangeYear<0">
          <img id="u4194_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u4194_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>
    </div>

</template>
<script>
import "echarts/theme/macarons";
import {
  getPerformanceLevel1,
  listPerformance,
} from "@/api/business/energy/performance";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
     components: {Pagination},
      props: {
      //接收父组件传来的值
      flag: Number
    },
  data() {
    
    return {
        flag: 1,
        jxflag: 0,
        radio: 0,
        // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      curseasonflag: 1,
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   performancetype: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
   feeTypeList: [
        { itemCode: 1, itemName: "单位产值" },
        { itemCode: 2, itemName: "单位面积综合" },
        { itemCode: 3, itemName: "单位面积电耗" },
        { itemCode: 4, itemName: "单位面积用水" },     
        { itemCode: 5, itemName: "单位面积空调" },
        { itemCode: 6, itemName: "人均综合能耗" },     
        { itemCode: 7, itemName: "单位人均电耗" },
        { itemCode: 8, itemName: "单位人均用水" },
    
      ],

      //1 总能耗
      yearAnalysis: [],
      seasonAnalysis: [],
      monthAnalysis: [],

      //2---单位产值
      unitoutputyearAnalysis: [],
      unitoutputseasonAnalysis: [],
      unitoutputmonthAnalysis: [],

      //3---单位面积能耗
      unitareaenergyyearAnalysis: [],
      unitareaenergyseasonAnalysis: [],
      unitareaenergymonthAnalysis: [],

      //4---单位面积电耗

      unitareapoweryearAnalysis: [],
      unitareapowerseasonAnalysis: [],
      unitareapowermonthAnalysis: [],

      //5--单位面积水耗
      unitareawateryearAnalysis: [],
      unitareawaterseasonAnalysis: [],
      unitareawatermonthAnalysis: [],

     //6--单位面积空调
      unitareaairyearAnalysis: [],
      unitareaairseasonAnalysis: [],
      unitareaairmonthAnalysis: [],

       //7---人均能耗
      peryearAnalysis: [],
      perseasonAnalysis: [],
      permonthAnalysis: [],
     
      //8--人均面积水耗
      perareawateryearAnalysis: [],
      perareawaterseasonAnalysis: [],
      perareawatermonthAnalysis: [],

      //9---单位面积电耗

      perareapoweryearAnalysis: [],
      perareapowerseasonAnalysis: [],
      perareapowermonthAnalysis: [],
     
      paramsData: [],

      //1 总能耗
      monthlyProportionOptions: null,
      monthlyProportionOptions1: null,
      seasonProportionOptions: null,
      seasonProportionOptions1: null,
      yearlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      seasonProportionOptionsRate: null,
      yearlyProportionOptionsRate: null,

      //2---单位产值
      unitoutputmonthlyProportionOptions: null,
      unitoutputseasonProportionOptions: null,
      unitoutputyearlyProportionOptions: null,
      unitoutputmonthlyProportionOptionsRate: null,
      unitoutputseasonProportionOptionsRate: null,
      unitoutputyearlyProportionOptionsRate: null,

       //3---单位面积能耗   
      unitareaenergymonthlyProportionOptions: null,
      unitareaenergyseasonProportionOptions: null,
      unitareaenergyyearlyProportionOptions: null,
      unitareaenergymonthlyProportionOptionsRate: null,
      unitareaenergyseasonProportionOptionsRate: null,
      unitareaenergyyearlyProportionOptionsRate: null,

      //4---单位面积电耗
      unitareapowermonthlyProportionOptions: null,
      unitareapowerseasonProportionOptions: null,
      unitareapoweryearlyProportionOptions: null,
      unitareapowermonthlyProportionOptionsRate: null,
      unitareapowerseasonProportionOptionsRate: null,
      unitareapoweryearlyProportionOptionsRate: null,
 
       //5---单位面积水耗
      unitareawatermonthlyProportionOptions: null,
      unitareawaterseasonProportionOptions: null,
      unitareawateryearlyProportionOptions: null,
      unitareawatermonthlyProportionOptionsRate: null,
      unitareawaterseasonProportionOptionsRate: null,
      unitareawateryearlyProportionOptionsRate: null,    

       //6---单位面积空调
      unitareaairmonthlyProportionOptions: null,
      unitareaairseasonProportionOptions: null,
      unitareaairyearlyProportionOptions: null,
      unitareaairmonthlyProportionOptionsRate: null,
      unitareaairseasonProportionOptionsRate: null,
      unitareaairyearlyProportionOptionsRate: null,  

       //7---人均能耗
      permonthlyProportionOptions: null,
      perseasonProportionOptions: null,
      peryearlyProportionOptions: null,
      permonthlyProportionOptionsRate: null,
      perseasonProportionOptionsRate: null,
      peryearlyProportionOptionsRate: null,    

       //8---人均电耗
      perpowermonthlyProportionOptions: null,
      perpowerseasonProportionOptions: null,
      perpoweryearlyProportionOptions: null,
      perpowermonthlyProportionOptionsRate: null,
      perpowerseasonProportionOptionsRate: null,
      perpoweryearlyProportionOptionsRate: null,    
       //9---人均水耗
      perwatermonthlyProportionOptions: null,
      perwaterseasonProportionOptions: null,
      perwateryearlyProportionOptions: null,
      perwatermonthlyProportionOptionsRate: null,
      perwaterseasonProportionOptionsRate: null,
      perwateryearlyProportionOptionsRate: null,    
        typeflag: 0,
        totalmonth: '',
        montharr: [],//月份
      montharr2: [],//月份
      dataarr: [],//目标值
      dataarr2: [],//实际值
      dataarr3: [],//预测值
      dataarr4: [],//评价
      forcastdata:null,
      rightHeader: [],
      rightsDate: [],
       tableData: [],
       besturl: "../../../../../../assets/common/performanc/icon/month/u3153.png",
       betterurl: "../../../../../../assets/common/performanc/icon/month/u3154.png",
       goodurl: "../../../../../../assets/common/performanc/icon/month/u3152.png",
      performanceLevel1VO: {
 //----------汇总数据-------------
    //今年总量
    totalYear: "",//0
    outputYear: "",//1
    areaenergyYear: "",//2
    areapowerYear: "",//3
    areawaterYear: "",//4
    areaairYear: "",//5
    perYear: "",//6
    perpowerYear: "",//7
    perwaterYear: "",//8


    //---今年用量变化
    totalChangeYear: "",//0
    outputChangeYear: "",//1
    areaenergyChangeYear: "",//2
    areapowerChangeYear: "",//3
    areawaterChangeYear: "",//4
    areaairChangeYear: "",//5
    perChangeYear: "",//6
    perpowerChangeYear: "",//7
    perwaterChangeYear: "",//8

    //---今年用量变化率
    totalChangerateYear: "",//0
    outputChangerateYear: "",//1
    areaenergyChangerateYear: "",//2
    areapowerChangerateYear: "",//3
    areawaterChangerateYear: "",//4
    areaairChangerateYear: "",//5
    perChangerateYear: "",//6
    perpowerChangerateYear: "",//7
    perwaterChangerateYear: "",//8


    //---今年用量评价
    totalEvaluateYear: "",//0
    outputEvaluateYear: "",//1
    areaenergyEvaluateYear: "",//2
    areapowerEvaluateYear: "",//3
    areawaterEvaluateYear: "",//4
    areaairEvaluateYear: "",//5
    perEvaluateYear: "",//6
    perpowerEvaluateYear: "",//7
    perwaterEvaluateYear: "",//8

    //--下一周期预测
    totalForecastYear: "",//0
    outputForecastYear: "",//1
    areaenergyForecastYear: "",//2
    areapowerForecastYear: "",//3
    areawaterForecastYear: "",//4
    areaairForecastYear: "",//5
    perForecastYear: "",//6
    perpowerForecastYear: "",//7
    perwaterForecastYear: "",//8




    //---------------总季度----------------------------------------

    //----总量
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",
    //---用量变化
    totalChangeSeason1: "",
    totalChangeSeason2: "",
    totalChangeSeason3: "",
    totalChangeSeason4: "",
    //---用量变化率
    totalChangeRateSeason1: "",
    totalChangeRateSeason2: "",
    totalChangeRateSeason3: "",
    totalChangeRateSeason4: "",
    //--用量评价
    totalEvaluateSeason1: "",
    totalEvaluateSeason2: "",
    totalEvaluateSeason3: "",
    totalEvaluateSeason4: "",
    //--下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //---------------单位产值季度----------------------------------------

    //----用量
    outputSeason1: "",
    outputSeason2: "",
    outputSeason3: "",
    outputSeason4: "",
    //---用量变化
    outputChangeSeason1: "",
    outputChangeSeason2: "",
    outputChangeSeason3: "",
    outputChangeSeason4: "",
    //---用量变化率
    outputChangeRateSeason1: "",
    outputChangeRateSeason2: "",
    outputChangeRateSeason3: "",
    outputChangeRateSeason4: "",
    //--用量评价
    outputEvaluateSeason1: "",
    outputEvaluateSeason2: "",
    outputEvaluateSeason3: "",
    outputEvaluateSeason4: "",
    //--下一周期预测
    outputForecastSeason1: "",
    outputForecastSeason2: "",
    outputForecastSeason3: "",
    outputForecastSeason4: "",

    //---------------单位面积季度----------------------------------------

    //----用量
    areaenergySeason1: "",
    areaenergySeason2: "",
    areaenergySeason3: "",
    areaenergySeason4: "",
    //---用量变化
    areaenergyChangeSeason1: "",
    areaenergyChangeSeason2: "",
    areaenergyChangeSeason3: "",
    areaenergyChangeSeason4: "",
    //---用量变化率
    areaenergyChangeRateSeason1: "",
    areaenergyChangeRateSeason2: "",
    areaenergyChangeRateSeason3: "",
    areaenergyChangeRateSeason4: "",
    //--用量评价
    areaenergyEvaluateSeason1: "",
    areaenergyEvaluateSeason2: "",
    areaenergyEvaluateSeason3: "",
    areaenergyEvaluateSeason4: "",
    //--下一周期预测
    areaenergyForecastSeason1: "",
    areaenergyForecastSeason2: "",
    areaenergyForecastSeason3: "",
    areaenergyForecastSeason4: "",


//---------------单位面积电耗季度----------------------------------------

    //----用量
    areapowerSeason1: "",
    areapowerSeason2: "",
    areapowerSeason3: "",
    areapowerSeason4: "",
    //---用量变化
    areapowerChangeSeason1: "",
    areapowerChangeSeason2: "",
    areapowerChangeSeason3: "",
    areapowerChangeSeason4: "",
    //---用量变化率
    areapowerChangeRateSeason1: "",
    areapowerChangeRateSeason2: "",
    areapowerChangeRateSeason3: "",
    areapowerChangeRateSeason4: "",
    //--用量评价
    areapowerEvaluateSeason1: "",
    areapowerEvaluateSeason2: "",
    areapowerEvaluateSeason3: "",
    areapowerEvaluateSeason4: "",
    //--下一周期预测
    areapowerForecastSeason1: "",
    areapowerForecastSeason2: "",
    areapowerForecastSeason3: "",
    areapowerForecastSeason4: "",


//---------------单位面积用水季度----------------------------------------

    //----用量
    areawaterSeason1: "",
    areawaterSeason2: "",
    areawaterSeason3: "",
    areawaterSeason4: "",
    //---用量变化
    areawaterChangeSeason1: "",
    areawaterChangeSeason2: "",
    areawaterChangeSeason3: "",
    areawaterChangeSeason4: "",
    //---用量变化率
    areawaterChangeRateSeason1: "",
    areawaterChangeRateSeason2: "",
    areawaterChangeRateSeason3: "",
    areawaterChangeRateSeason4: "",
    //--用量评价
    areawaterEvaluateSeason1: "",
    areawaterEvaluateSeason2: "",
    areawaterEvaluateSeason3: "",
    areawaterEvaluateSeason4: "",
    //--下一周期预测
    areawaterForecastSeason1: "",
    areawaterForecastSeason2: "",
    areawaterForecastSeason3: "",
    areawaterForecastSeason4: "",


//---------------单位空调季度----------------------------------------

    //----用量
    areaairSeason1: "",
    areaairSeason2: "",
    areaairSeason3: "",
    areaairSeason4: "",
    //---用量变化
    areaairChangeSeason1: "",
    areaairChangeSeason2: "",
    areaairChangeSeason3: "",
    areaairChangeSeason4: "",
    //---用量变化率
    areaairChangeRateSeason1: "",
    areaairChangeRateSeason2: "",
    areaairChangeRateSeason3: "",
    areaairChangeRateSeason4: "",
    //--用量评价
    areaairEvaluateSeason1: "",
    areaairEvaluateSeason2: "",
    areaairEvaluateSeason3: "",
    areaairEvaluateSeason4: "",
    //--下一周期预测
    areaairForecastSeason1: "",
    areaairForecastSeason2: "",
    areaairForecastSeason3: "",
    areaairForecastSeason4: "",


//---------------单位人均能耗季度----------------------------------------

    //----用量
    perSeason1: "",
    perSeason2: "",
    perSeason3: "",
    perSeason4: "",
    //---用量变化
    perChangeSeason1: "",
    perChangeSeason2: "",
    perChangeSeason3: "",
    perChangeSeason4: "",
    //---用量变化率
    perChangeRateSeason1: "",
    perChangeRateSeason2: "",
    perChangeRateSeason3: "",
    perChangeRateSeason4: "",
    //--用量评价
    perEvaluateSeason1: "",
    perEvaluateSeason2: "",
    perEvaluateSeason3: "",
    perEvaluateSeason4: "",
    //--下一周期预测
    perForecastSeason1: "",
    perForecastSeason2: "",
    perForecastSeason3: "",
    perForecastSeason4: "",


//---------------单位人均电耗季度----------------------------------------

    //----用量
    perpowerSeason1: "",
    perpowerSeason2: "",
    perpowerSeason3: "",
    perpowerSeason4: "",
    //---用量变化
    perpowerChangeSeason1: "",
    perpowerChangeSeason2: "",
    perpowerChangeSeason3: "",
    perpowerChangeSeason4: "",
    //---用量变化率
    perpowerChangeRateSeason1: "",
    perpowerChangeRateSeason2: "",
    perpowerChangeRateSeason3: "",
    perpowerChangeRateSeason4: "",
    //--用量评价
    perpowerEvaluateSeason1: "",
    perpowerEvaluateSeason2: "",
    perpowerEvaluateSeason3: "",
    perpowerEvaluateSeason4: "",
    //--下一周期预测
    perpowerForecastSeason1: "",
    perpowerForecastSeason2: "",
    perpowerForecastSeason3: "",
    perpowerForecastSeason4: "",


//---------------单位人均水耗季度----------------------------------------

    //----用量
    perwaterSeason1: "",
    perwaterSeason2: "",
    perwaterSeason3: "",
    perwaterSeason4: "",
    //---用量变化
    perwaterChangeSeason1: "",
    perwaterChangeSeason2: "",
    perwaterChangeSeason3: "",
    perwaterChangeSeason4: "",
    //---用量变化率
    perwaterChangeRateSeason1: "",
    perwaterChangeRateSeason2: "",
    perwaterChangeRateSeason3: "",
    perwaterChangeRateSeason4: "",
    //--用量评价
    perwaterEvaluateSeason1: "",
    perwaterEvaluateSeason2: "",
    perwaterEvaluateSeason3: "",
    perwaterEvaluateSeason4: "",
    //--下一周期预测
    perwaterForecastSeason1: "",
    perwaterForecastSeason2: "",
    perwaterForecastSeason3: "",
    perwaterForecastSeason4: "",

    //-------------总能耗月量----------------------------月量----------------------------
    //总量
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //变化
    totalChangeMonth1: "",
    totalChangeMonth2: "",
    totalChangeMonth3: "",
    totalChangeMonth4: "",
    totalChangeMonth5: "",
    totalChangeMonth6: "",
    totalChangeMonth7: "",
    totalChangeMonth8: "",
    totalChangeMonth9: "",
    totalChangeMonth10: "",
    totalChangeMonth11: "",
    totalChangeMonth12: "",
    //---变化率
    totalChangeRateMonth1: "",
    totalChangeRateMonth2: "",
    totalChangeRateMonth3: "",
    totalChangeRateMonth4: "",
    totalChangeRateMonth5: "",
    totalChangeRateMonth6: "",
    totalChangeRateMonth7: "",
    totalChangeRateMonth8: "",
    totalChangeRateMonth9: "",
    totalChangeRateMonth10: "",
    totalChangeRateMonth11: "",
    totalChangeRateMonth12: "",
    //--评价
    totalEvaluateMonth1: "",
    totalEvaluateMonth2: "",
    totalEvaluateMonth3: "",
    totalEvaluateMonth4: "",
    totalEvaluateMonth5: "",
    totalEvaluateMonth6: "",
    totalEvaluateMonth7: "",
    totalEvaluateMonth8: "",
    totalEvaluateMonth9: "",
    totalEvaluateMonth10: "",
    totalEvaluateMonth11: "",
    totalEvaluateMonth12: "",

    //--下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------单位产值能耗月量----------------------------
    //总量
    outputMonth1: "",
    outputMonth2: "",
    outputMonth3: "",
    outputMonth4: "",
    outputMonth5: "",
    outputMonth6: "",
    outputMonth7: "",
    outputMonth8: "",
    outputMonth9: "",
    outputMonth10: "",
    outputMonth11: "",
    outputMonth12: "",

    //变化
    outputChangeMonth1: "",
    outputChangeMonth2: "",
    outputChangeMonth3: "",
    outputChangeMonth4: "",
    outputChangeMonth5: "",
    outputChangeMonth6: "",
    outputChangeMonth7: "",
    outputChangeMonth8: "",
    outputChangeMonth9: "",
    outputChangeMonth10: "",
    outputChangeMonth11: "",
    outputChangeMonth12: "",
    //---变化率
    outputChangeRateMonth1: "",
    outputChangeRateMonth2: "",
    outputChangeRateMonth3: "",
    outputChangeRateMonth4: "",
    outputChangeRateMonth5: "",
    outputChangeRateMonth6: "",
    outputChangeRateMonth7: "",
    outputChangeRateMonth8: "",
    outputChangeRateMonth9: "",
    outputChangeRateMonth10: "",
    outputChangeRateMonth11: "",
    outputChangeRateMonth12: "",
    //--评价
    outputEvaluateMonth1: "",
    outputEvaluateMonth2: "",
    outputEvaluateMonth3: "",
    outputEvaluateMonth4: "",
    outputEvaluateMonth5: "",
    outputEvaluateMonth6: "",
    outputEvaluateMonth7: "",
    outputEvaluateMonth8: "",
    outputEvaluateMonth9: "",
    outputEvaluateMonth10: "",
    outputEvaluateMonth11: "",
    outputEvaluateMonth12: "",

    //--下一周期预测
    outputForecastMonth1: "",
    outputForecastMonth2: "",
    outputForecastMonth3: "",
    outputForecastMonth4: "",
    outputForecastMonth5: "",
    outputForecastMonth6: "",
    outputForecastMonth7: "",
    outputForecastMonth8: "",
    outputForecastMonth9: "",
    outputForecastMonth10: "",
    outputForecastMonth11: "",
    outputForecastMonth12: "",

    //-------------单位面积能耗月量----------------------------
    //总量
    areaenergyMonth1: "",
    areaenergyMonth2: "",
    areaenergyMonth3: "",
    areaenergyMonth4: "",
    areaenergyMonth5: "",
    areaenergyMonth6: "",
    areaenergyMonth7: "",
    areaenergyMonth8: "",
    areaenergyMonth9: "",
    areaenergyMonth10: "",
    areaenergyMonth11: "",
    areaenergyMonth12: "",

    //变化
    areaenergyChangeMonth1: "",
    areaenergyChangeMonth2: "",
    areaenergyChangeMonth3: "",
    areaenergyChangeMonth4: "",
    areaenergyChangeMonth5: "",
    areaenergyChangeMonth6: "",
    areaenergyChangeMonth7: "",
    areaenergyChangeMonth8: "",
    areaenergyChangeMonth9: "",
    areaenergyChangeMonth10: "",
    areaenergyChangeMonth11: "",
    areaenergyChangeMonth12: "",
    //---变化率
    areaenergyChangeRateMonth1: "",
    areaenergyChangeRateMonth2: "",
    areaenergyChangeRateMonth3: "",
    areaenergyChangeRateMonth4: "",
    areaenergyChangeRateMonth5: "",
    areaenergyChangeRateMonth6: "",
    areaenergyChangeRateMonth7: "",
    areaenergyChangeRateMonth8: "",
    areaenergyChangeRateMonth9: "",
    areaenergyChangeRateMonth10: "",
    areaenergyChangeRateMonth11: "",
    areaenergyChangeRateMonth12: "",
    //--评价
    areaenergyEvaluateMonth1: "",
    areaenergyEvaluateMonth2: "",
    areaenergyEvaluateMonth3: "",
    areaenergyEvaluateMonth4: "",
    areaenergyEvaluateMonth5: "",
    areaenergyEvaluateMonth6: "",
    areaenergyEvaluateMonth7: "",
    areaenergyEvaluateMonth8: "",
    areaenergyEvaluateMonth9: "",
    areaenergyEvaluateMonth10: "",
    areaenergyEvaluateMonth11: "",
    areaenergyEvaluateMonth12: "",

    //--下一周期预测
    areaenergyForecastMonth1: "",
    areaenergyForecastMonth2: "",
    areaenergyForecastMonth3: "",
    areaenergyForecastMonth4: "",
    areaenergyForecastMonth5: "",
    areaenergyForecastMonth6: "",
    areaenergyForecastMonth7: "",
    areaenergyForecastMonth8: "",
    areaenergyForecastMonth9: "",
    areaenergyForecastMonth10: "",
    areaenergyForecastMonth11: "",
    areaenergyForecastMonth12: "",

    //-------------单位面积能耗月量----------------------------
    //总量
    areapowerMonth1: "",
    areapowerMonth2: "",
    areapowerMonth3: "",
    areapowerMonth4: "",
    areapowerMonth5: "",
    areapowerMonth6: "",
    areapowerMonth7: "",
    areapowerMonth8: "",
    areapowerMonth9: "",
    areapowerMonth10: "",
    areapowerMonth11: "",
    areapowerMonth12: "",

    //变化
    areapowerChangeMonth1: "",
    areapowerChangeMonth2: "",
    areapowerChangeMonth3: "",
    areapowerChangeMonth4: "",
    areapowerChangeMonth5: "",
    areapowerChangeMonth6: "",
    areapowerChangeMonth7: "",
    areapowerChangeMonth8: "",
    areapowerChangeMonth9: "",
    areapowerChangeMonth10: "",
    areapowerChangeMonth11: "",
    areapowerChangeMonth12: "",
    //---变化率
    areapowerChangeRateMonth1: "",
    areapowerChangeRateMonth2: "",
    areapowerChangeRateMonth3: "",
    areapowerChangeRateMonth4: "",
    areapowerChangeRateMonth5: "",
    areapowerChangeRateMonth6: "",
    areapowerChangeRateMonth7: "",
    areapowerChangeRateMonth8: "",
    areapowerChangeRateMonth9: "",
    areapowerChangeRateMonth10: "",
    areapowerChangeRateMonth11: "",
    areapowerChangeRateMonth12: "",
    //--评价
    areapowerEvaluateMonth1: "",
    areapowerEvaluateMonth2: "",
    areapowerEvaluateMonth3: "",
    areapowerEvaluateMonth4: "",
    areapowerEvaluateMonth5: "",
    areapowerEvaluateMonth6: "",
    areapowerEvaluateMonth7: "",
    areapowerEvaluateMonth8: "",
    areapowerEvaluateMonth9: "",
    areapowerEvaluateMonth10: "",
    areapowerEvaluateMonth11: "",
    areapowerEvaluateMonth12: "",

    //--下一周期预测
    areapowerForecastMonth1: "",
    areapowerForecastMonth2: "",
    areapowerForecastMonth3: "",
    areapowerForecastMonth4: "",
    areapowerForecastMonth5: "",
    areapowerForecastMonth6: "",
    areapowerForecastMonth7: "",
    areapowerForecastMonth8: "",
    areapowerForecastMonth9: "",
    areapowerForecastMonth10: "",
    areapowerForecastMonth11: "",
    areapowerForecastMonth12: "",

    //-------------单位面积单耗月量----------------------------
    //总量
    areawaterMonth1: "",
    areawaterMonth2: "",
    areawaterMonth3: "",
    areawaterMonth4: "",
    areawaterMonth5: "",
    areawaterMonth6: "",
    areawaterMonth7: "",
    areawaterMonth8: "",
    areawaterMonth9: "",
    areawaterMonth10: "",
    areawaterMonth11: "",
    areawaterMonth12: "",

    //变化
    areawaterChangeMonth1: "",
    areawaterChangeMonth2: "",
    areawaterChangeMonth3: "",
    areawaterChangeMonth4: "",
    areawaterChangeMonth5: "",
    areawaterChangeMonth6: "",
    areawaterChangeMonth7: "",
    areawaterChangeMonth8: "",
    areawaterChangeMonth9: "",
    areawaterChangeMonth10: "",
    areawaterChangeMonth11: "",
    areawaterChangeMonth12: "",
    //---变化率
    areawaterChangeRateMonth1: "",
    areawaterChangeRateMonth2: "",
    areawaterChangeRateMonth3: "",
    areawaterChangeRateMonth4: "",
    areawaterChangeRateMonth5: "",
    areawaterChangeRateMonth6: "",
    areawaterChangeRateMonth7: "",
    areawaterChangeRateMonth8: "",
    areawaterChangeRateMonth9: "",
    areawaterChangeRateMonth10: "",
    areawaterChangeRateMonth11: "",
    areawaterChangeRateMonth12: "",
    //--评价
    areawaterEvaluateMonth1: "",
    areawaterEvaluateMonth2: "",
    areawaterEvaluateMonth3: "",
    areawaterEvaluateMonth4: "",
    areawaterEvaluateMonth5: "",
    areawaterEvaluateMonth6: "",
    areawaterEvaluateMonth7: "",
    areawaterEvaluateMonth8: "",
    areawaterEvaluateMonth9: "",
    areawaterEvaluateMonth10: "",
    areawaterEvaluateMonth11: "",
    areawaterEvaluateMonth12: "",

    //--下一周期预测
    areawaterForecastMonth1: "",
    areawaterForecastMonth2: "",
    areawaterForecastMonth3: "",
    areawaterForecastMonth4: "",
    areawaterForecastMonth5: "",
    areawaterForecastMonth6: "",
    areawaterForecastMonth7: "",
    areawaterForecastMonth8: "",
    areawaterForecastMonth9: "",
    areawaterForecastMonth10: "",
    areawaterForecastMonth11: "",
    areawaterForecastMonth12: "",

    //-------------单位空调月量----------------------------
    //总量
    areaairMonth1: "",
    areaairMonth2: "",
    areaairMonth3: "",
    areaairMonth4: "",
    areaairMonth5: "",
    areaairMonth6: "",
    areaairMonth7: "",
    areaairMonth8: "",
    areaairMonth9: "",
    areaairMonth10: "",
    areaairMonth11: "",
    areaairMonth12: "",

    //变化
    areaairChangeMonth1: "",
    areaairChangeMonth2: "",
    areaairChangeMonth3: "",
    areaairChangeMonth4: "",
    areaairChangeMonth5: "",
    areaairChangeMonth6: "",
    areaairChangeMonth7: "",
    areaairChangeMonth8: "",
    areaairChangeMonth9: "",
    areaairChangeMonth10: "",
    areaairChangeMonth11: "",
    areaairChangeMonth12: "",
    //---变化率
    areaairChangeRateMonth1: "",
    areaairChangeRateMonth2: "",
    areaairChangeRateMonth3: "",
    areaairChangeRateMonth4: "",
    areaairChangeRateMonth5: "",
    areaairChangeRateMonth6: "",
    areaairChangeRateMonth7: "",
    areaairChangeRateMonth8: "",
    areaairChangeRateMonth9: "",
    areaairChangeRateMonth10: "",
    areaairChangeRateMonth11: "",
    areaairChangeRateMonth12: "",
    //--评价
    areaairEvaluateMonth1: "",
    areaairEvaluateMonth2: "",
    areaairEvaluateMonth3: "",
    areaairEvaluateMonth4: "",
    areaairEvaluateMonth5: "",
    areaairEvaluateMonth6: "",
    areaairEvaluateMonth7: "",
    areaairEvaluateMonth8: "",
    areaairEvaluateMonth9: "",
    areaairEvaluateMonth10: "",
    areaairEvaluateMonth11: "",
    areaairEvaluateMonth12: "",

    //--下一周期预测
    areaairForecastMonth1: "",
    areaairForecastMonth2: "",
    areaairForecastMonth3: "",
    areaairForecastMonth4: "",
    areaairForecastMonth5: "",
    areaairForecastMonth6: "",
    areaairForecastMonth7: "",
    areaairForecastMonth8: "",
    areaairForecastMonth9: "",
    areaairForecastMonth10: "",
    areaairForecastMonth11: "",
    areaairForecastMonth12: "",

    //-------------人均能耗月量----------------------------
    //总量
    perMonth1: "",
    perMonth2: "",
    perMonth3: "",
    perMonth4: "",
    perMonth5: "",
    perMonth6: "",
    perMonth7: "",
    perMonth8: "",
    perMonth9: "",
    perMonth10: "",
    perMonth11: "",
    perMonth12: "",

    //变化
    perChangeMonth1: "",
    perChangeMonth2: "",
    perChangeMonth3: "",
    perChangeMonth4: "",
    perChangeMonth5: "",
    perChangeMonth6: "",
    perChangeMonth7: "",
    perChangeMonth8: "",
    perChangeMonth9: "",
    perChangeMonth10: "",
    perChangeMonth11: "",
    perChangeMonth12: "",
    //---变化率
    perChangeRateMonth1: "",
    perChangeRateMonth2: "",
    perChangeRateMonth3: "",
    perChangeRateMonth4: "",
    perChangeRateMonth5: "",
    perChangeRateMonth6: "",
    perChangeRateMonth7: "",
    perChangeRateMonth8: "",
    perChangeRateMonth9: "",
    perChangeRateMonth10: "",
    perChangeRateMonth11: "",
    perChangeRateMonth12: "",
    //--评价
    perEvaluateMonth1: "",
    perEvaluateMonth2: "",
    perEvaluateMonth3: "",
    perEvaluateMonth4: "",
    perEvaluateMonth5: "",
    perEvaluateMonth6: "",
    perEvaluateMonth7: "",
    perEvaluateMonth8: "",
    perEvaluateMonth9: "",
    perEvaluateMonth10: "",
    perEvaluateMonth11: "",
    perEvaluateMonth12: "",

    //--下一周期预测
    perForecastMonth1: "",
    perForecastMonth2: "",
    perForecastMonth3: "",
    perForecastMonth4: "",
    perForecastMonth5: "",
    perForecastMonth6: "",
    perForecastMonth7: "",
    perForecastMonth8: "",
    perForecastMonth9: "",
    perForecastMonth10: "",
    perForecastMonth11: "",
    perForecastMonth12: "",

    //-------------人均电耗月量----------------------------
    //总量
    perpowerMonth1: "",
    perpowerMonth2: "",
    perpowerMonth3: "",
    perpowerMonth4: "",
    perpowerMonth5: "",
    perpowerMonth6: "",
    perpowerMonth7: "",
    perpowerMonth8: "",
    perpowerMonth9: "",
    perpowerMonth10: "",
    perpowerMonth11: "",
    perpowerMonth12: "",

    //变化
    perpowerChangeMonth1: "",
    perpowerChangeMonth2: "",
    perpowerChangeMonth3: "",
    perpowerChangeMonth4: "",
    perpowerChangeMonth5: "",
    perpowerChangeMonth6: "",
    perpowerChangeMonth7: "",
    perpowerChangeMonth8: "",
    perpowerChangeMonth9: "",
    perpowerChangeMonth10: "",
    perpowerChangeMonth11: "",
    perpowerChangeMonth12: "",
    //---变化率
    perpowerChangeRateMonth1: "",
    perpowerChangeRateMonth2: "",
    perpowerChangeRateMonth3: "",
    perpowerChangeRateMonth4: "",
    perpowerChangeRateMonth5: "",
    perpowerChangeRateMonth6: "",
    perpowerChangeRateMonth7: "",
    perpowerChangeRateMonth8: "",
    perpowerChangeRateMonth9: "",
    perpowerChangeRateMonth10: "",
    perpowerChangeRateMonth11: "",
    perpowerChangeRateMonth12: "",
    //--评价
    perpowerEvaluateMonth1: "",
    perpowerEvaluateMonth2: "",
    perpowerEvaluateMonth3: "",
    perpowerEvaluateMonth4: "",
    perpowerEvaluateMonth5: "",
    perpowerEvaluateMonth6: "",
    perpowerEvaluateMonth7: "",
    perpowerEvaluateMonth8: "",
    perpowerEvaluateMonth9: "",
    perpowerEvaluateMonth10: "",
    perpowerEvaluateMonth11: "",
    perpowerEvaluateMonth12: "",

    //--下一周期预测
    perpowerForecastMonth1: "",
    perpowerForecastMonth2: "",
    perpowerForecastMonth3: "",
    perpowerForecastMonth4: "",
    perpowerForecastMonth5: "",
    perpowerForecastMonth6: "",
    perpowerForecastMonth7: "",
    perpowerForecastMonth8: "",
    perpowerForecastMonth9: "",
    perpowerForecastMonth10: "",
    perpowerForecastMonth11: "",
    perpowerForecastMonth12: "",


    //-------------人均水耗月量----------------------------
    //总量
    perwaterMonth1: "",
    perwaterMonth2: "",
    perwaterMonth3: "",
    perwaterMonth4: "",
    perwaterMonth5: "",
    perwaterMonth6: "",
    perwaterMonth7: "",
    perwaterMonth8: "",
    perwaterMonth9: "",
    perwaterMonth10: "",
    perwaterMonth11: "",
    perwaterMonth12: "",

    //变化
    perwaterChangeMonth1: "",
    perwaterChangeMonth2: "",
    perwaterChangeMonth3: "",
    perwaterChangeMonth4: "",
    perwaterChangeMonth5: "",
    perwaterChangeMonth6: "",
    perwaterChangeMonth7: "",
    perwaterChangeMonth8: "",
    perwaterChangeMonth9: "",
    perwaterChangeMonth10: "",
    perwaterChangeMonth11: "",
    perwaterChangeMonth12: "",
    //---变化率
    perwaterChangeRateMonth1: "",
    perwaterChangeRateMonth2: "",
    perwaterChangeRateMonth3: "",
    perwaterChangeRateMonth4: "",
    perwaterChangeRateMonth5: "",
    perwaterChangeRateMonth6: "",
    perwaterChangeRateMonth7: "",
    perwaterChangeRateMonth8: "",
    perwaterChangeRateMonth9: "",
    perwaterChangeRateMonth10: "",
    perwaterChangeRateMonth11: "",
    perwaterChangeRateMonth12: "",
    //--评价
    perwaterEvaluateMonth1: "",
    perwaterEvaluateMonth2: "",
    perwaterEvaluateMonth3: "",
    perwaterEvaluateMonth4: "",
    perwaterEvaluateMonth5: "",
    perwaterEvaluateMonth6: "",
    perwaterEvaluateMonth7: "",
    perwaterEvaluateMonth8: "",
    perwaterEvaluateMonth9: "",
    perwaterEvaluateMonth10: "",
    perwaterEvaluateMonth11: "",
    perwaterEvaluateMonth12: "",

    //--下一周期预测
    perwaterForecastMonth1: "",
    perwaterForecastMonth2: "",
    perwaterForecastMonth3: "",
    perwaterForecastMonth4: "",
    perwaterForecastMonth5: "",
    perwaterForecastMonth6: "",
    perwaterForecastMonth7: "",
    perwaterForecastMonth8: "",
    perwaterForecastMonth9: "",
    perwaterForecastMonth10: "",
    perwaterForecastMonth11: "",
    perwaterForecastMonth12: "",
      }
    };
  },
  created() {

    getPerformanceLevel1(this.queryParams).then((response) => {
          
          this.performanceLevel1VO = response.data;
        //this.typeflag=0;
     //1 总能耗
    //this.seasonProportionOptions=this.seasonProportionRate(0);
    
      // this.monthlyProportionOptions=this.monthlyProportionRate2(0);
      // this.seasonProportionOptions=this.seasonProportion(),
      // this.yearlyProportionOptions=this.yearlyProportion(),
     // alert(22);
          
         });
    
   
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
        // alert("child="+iflag);

     },
               /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
           /** 查询列表 */
    getList() {
      this.loading = true;
     
      listPerformance(this.queryParams).then((response) => {
        
        for(var i=0;i<response.rows.length;i++){
          if(response.rows[i].performancetype==0){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='总能耗';
            }
            if(response.rows[i].performancetype==1){
             response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;   response.rows[i].performancetype='电';
           response.rows[i].performancetype='单位产值能耗';
           }
            if(response.rows[i].performancetype==2){
           response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
              
               response.rows[i].performancetype='单位面积能耗';}
              if(response.rows[i].performancetype==3){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
              
               response.rows[i].performancetype='单位面积电耗';}
            
            if(response.rows[i].performancetype==4){
           response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;  
               response.rows[i].performancetype='单位面积用水';
            }
              if(response.rows[i].performancetype==5){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='单位空调用电'; 
              }
               if(response.rows[i].performancetype==6){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='人均能耗';}
            
            if(response.rows[i].performancetype==7){
              response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='单位人均电耗';
            }
              if(response.rows[i].performancetype==8){
               response.rows[i].performancemonth=response.rows[i].performanceyear+'-'+response.rows[i].performancemonth;
               response.rows[i].performancetype='单位人均用水'; 
              }
        }
      
        this.consumptionList = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
     
   }
}
</script>
<style scoped>
  @import "../../../../../../assets/common/performance/css/year/styles.css";
  @import "../../../../../../assets/common/consumption/css/styles.css";
  @import "../../../../../../assets/common/rp_page.css";
</style>
